import { useEffect, useCallback } from 'react'
import throttle from 'lodash/throttle'

const Scroller = function Scroller({ onChange, throttleDelay, cancelsScroll = false }) {
  const callback = useCallback(
    throttle(() => {
      onChange(window.pageYOffset)
    }, throttleDelay),
    [throttleDelay],
  )

  useEffect(() => {
    window.addEventListener('scroll', callback, { passive: !cancelsScroll })

    return () => {
      window.removeEventListener('scroll', callback)
    }
  }, [callback, cancelsScroll])

  return null
}

export default Scroller
